"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6007,4693],{

/***/ 1109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useFetchExcludedEvalIds; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41562);
/* harmony import */ var src_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18467);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64443);






var useFetchExcludedEvalIds = function(initExcludeEvalIds) {
    var isGuest = (0,src_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCheckPatientLogIn */ .de)().isGuest;
    var platform = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_5__/* .platformState */ .QQ);
    var ref = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_2__.useGetExcludedEvaluationIdsQuery)(graphql_react_query__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        input: {
            platform: platform
        }
    }, {
        enabled: lodash__WEBPACK_IMPORTED_MODULE_0___default().isEmpty(initExcludeEvalIds) && !isGuest
    }), loading = ref.isLoading, data = ref.data;
    return {
        loading: loading,
        excludedEvalIds: (data === null || data === void 0 ? void 0 : data.getExcludedEvaluationIds) || initExcludeEvalIds || []
    };
};


/***/ }),

/***/ 84693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Loading_WholePageLoading; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./design_system/icons/SpinnerIcon.tsx




var SvgSpinnerIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: size,
        height: size,
        viewBox: "0 0 2400 2400",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")")
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            stroke: color,
            strokeLinecap: "round",
            strokeWidth: 200,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1200 600V100"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1200 2300v-500",
                    opacity: 0.5
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m900 680.4-250-433",
                    opacity: 0.917
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m1750 2152.6-250-433",
                    opacity: 0.417
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m680.4 900-433-250",
                    opacity: 0.833
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m2152.6 1750-433-250",
                    opacity: 0.333
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M600 1200H100",
                    opacity: 0.75
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M2300 1200h-500",
                    opacity: 0.25
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m680.4 1500-433 250",
                    opacity: 0.667
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m2152.6 650-433 250",
                    opacity: 0.167
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m900 1719.6-250 433",
                    opacity: 0.583
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "m1750 247.4-250 433",
                    opacity: 0.083
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("animateTransform", {
                    attributeName: "transform",
                    attributeType: "XML",
                    begin: "0s",
                    calcMode: "discrete",
                    dur: "1s",
                    keyTimes: "0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667",
                    repeatCount: "indefinite",
                    type: "rotate",
                    values: "0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199"
                })
            ]
        })
    }));
};
/* harmony default export */ var SpinnerIcon = (SvgSpinnerIcon);

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./design_system/components/Loading/Loading.tsx







var Loading = function(_param) {
    var size = _param.size, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "100",
        bg: "transparent",
        id: "loading"
    }, rest), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SpinnerIcon, {
            size: size,
            color: colors/* colors.orange.400 */.O.orange[400]
        })
    }));
};

;// CONCATENATED MODULE: ./design_system/components/Loading/index.ts


;// CONCATENATED MODULE: ./components/Loading/WholePageLoading.tsx


var WholePageLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading, {
        size: 61,
        h: "100vh"
    });
};
/* harmony default export */ var Loading_WholePageLoading = (WholePageLoading);


/***/ }),

/***/ 14262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gb": function() { return /* reexport */ Loading; },
  "Aj": function() { return /* reexport */ Loading_LoadingProgress; },
  "ok": function() { return /* reexport */ WholePageLoading["default"]; },
  "Ul": function() { return /* reexport */ Loading_WholePageProgress; }
});

// EXTERNAL MODULE: ./components/Loading/WholePageLoading.tsx + 3 modules
var WholePageLoading = __webpack_require__(84693);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/progress/dist/index.esm.js
var dist_index_esm = __webpack_require__(51943);
;// CONCATENATED MODULE: ./components/Loading/LoadingProgress.tsx


// TODO: remove when we have DS for loading
var LoadingProgress = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        w: "100%",
        h: "100%",
        position: "absolute",
        zIndex: 1000,
        left: 0,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                backgroundColor: "#ffffff",
                opacity: 0.6,
                zIndex: 1,
                width: "100%",
                height: "100%"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* CircularProgress */.D8, {
                isIndeterminate: true,
                color: "primary.500",
                position: "absolute",
                zIndex: 2,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            })
        ]
    });
};
/* harmony default export */ var Loading_LoadingProgress = (LoadingProgress);

// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./components/Loading/WholePageProgress.tsx



// TODO: remove when use DS
var WholePageProgress = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        w: "100vw",
        h: "100vh",
        id: "page-progress",
        position: "fixed",
        zIndex: 1000,
        left: 0,
        top: 0,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                position: "absolute",
                backgroundColor: colors/* colors.white.default */.O.white["default"],
                opacity: 0.6,
                zIndex: 1,
                width: "100%",
                height: "100%"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* CircularProgress */.D8, {
                isIndeterminate: true,
                color: "primary.500",
                position: "absolute",
                zIndex: 2,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)"
            })
        ]
    });
};
/* harmony default export */ var Loading_WholePageProgress = (WholePageProgress);

// EXTERNAL MODULE: ./node_modules/react-spinners/index.js
var react_spinners = __webpack_require__(74040);
;// CONCATENATED MODULE: ./components/Loading/Loading.tsx



var Loading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
        position: "absolute",
        w: "100%",
        height: "100%",
        top: "0",
        left: "0",
        justify: "center",
        alignItems: "center",
        zIndex: "100",
        bg: "transparent",
        id: "loading",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
            justify: "center",
            alignItems: "center",
            position: "relative",
            bg: "rgba(0,0,0,0.1)",
            width: "100px",
            height: "100px",
            borderRadius: "10px",
            boxShadow: "lg",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_spinners.CircleLoader, {
                color: "#5383ff",
                loading: true,
                size: "50px"
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/Loading/index.ts






/***/ }),

/***/ 95979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports GynaeGroupProducts, checkOrderGynaeHormoneTest */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88767);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4480);
/* harmony import */ var graphql_generated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12705);
/* harmony import */ var graphql_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41562);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86704);
/* harmony import */ var src_constants_url_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97479);
/* harmony import */ var src_states__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64443);
/* harmony import */ var src_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49384);
/* harmony import */ var src_utils_checkCountry__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42304);
/* harmony import */ var src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86229);
/* harmony import */ var _Dashboard_hooks_useFetchExcludedEvalIds__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1109);
/* eslint-disable react-hooks/exhaustive-deps */ 



















var GynaeGroupProducts = [
    graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.FertilityHormoneTestKit,
    graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.GynaeConsultHormoneTest,
    graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.GynaeConsult
];
// return true if there's exist one product in group GynaeGroupProducts and in productNames
var checkOrderGynaeHormoneTest = function(product, productNames) {
    return GynaeGroupProducts.includes(product.uniqName) && (0,lodash__WEBPACK_IMPORTED_MODULE_1__.intersectionWith)(productNames, GynaeGroupProducts, lodash__WEBPACK_IMPORTED_MODULE_1__.isEqual).length !== 0;
};
var useCartHooks = function() {
    var isSuggestion = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, initExcludeEvalIds = arguments.length > 1 ? arguments[1] : void 0;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_5__.useQueryClient)();
    var patient = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .patientState */ .ao);
    var ref = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_7__.useUpdateCartItemByIdMutation)(graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), updateCartItemById = ref.mutateAsync;
    var ref1 = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_7__.useInsertCartItemByIdMutation)(graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), insertCartItemById = ref1.mutateAsync, insertCartItemByIdAsync = ref1.mutateAsync;
    var ref2 = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_7__.useDeleteCartItemByIdMutation)(graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z), deleteCartItemById = ref2.mutateAsync;
    var refetch = (0,graphql_generated__WEBPACK_IMPORTED_MODULE_7__.useGetCartQuery)(graphql_react_query__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        input: {
            shouldReturnCalculation: false
        }
    }, {
        enabled: false
    }).refetch;
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .cartState */ .dl), 2), cart = ref3[0], setCart = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .priceModalSelectedProductState */ .If), 2), selectedProduct = ref4[0], setSelectedProduct = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isPriceModalOpenedState */ .R5), 2), isModalOpened = ref5[0], toggleModal = ref5[1];
    var setPreselectPrice = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .priceModalSelectedPriceState */ .Hq);
    var setIsAdding = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isAddingCartState */ .G6);
    var platform = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .platformState */ .QQ);
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isBuyNowState */ .g0), 2), isBuyNow = ref6[0], setIsBuyNow = ref6[1];
    var setModalCancelingItem = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .modalCancelingItemState */ .mq);
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .suggestionItemsState */ .Tl), 2), suggestionItems = ref7[0], setSuggestionItems = ref7[1];
    var setOrderCalculation = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .orderCalculationState */ .jJ);
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilState */ .FV)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isCartUpdatingState */ .O2), 2), isUpdating = ref8[0], setIsUpdating = ref8[1];
    var promoCode = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .promoCodeState */ .FZ);
    var setIsDetailModalOpened = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isDetailModalOpenedState */ .Am);
    var setSameEvalModalOpened = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isSameEvalModalOpenedState */ .Gz);
    var setSameEvalId = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .sameEvalIdState */ ._n);
    var setIsConflictPlatformModalOpened = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isConfictPlatform */ .mD);
    var activeProducts = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .activeProductsState */ .JN);
    var pendingEvalIds = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .pendingEvalIdsState */ .tN);
    var setIsRemoving = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .isCancelModalRemovingState */ .Vz);
    var excludedEvalIds = (0,_Dashboard_hooks_useFetchExcludedEvalIds__WEBPACK_IMPORTED_MODULE_15__/* .useFetchExcludedEvalIds */ .q)(initExcludeEvalIds).excludedEvalIds;
    var ref9;
    var completedEvalIds = (ref9 = activeProducts === null || activeProducts === void 0 ? void 0 : activeProducts.completedEvalIds) !== null && ref9 !== void 0 ? ref9 : [];
    var ref10;
    var skippedEvalIds = (ref10 = activeProducts === null || activeProducts === void 0 ? void 0 : activeProducts.skippedEvalIds) !== null && ref10 !== void 0 ? ref10 : [];
    // react state needSelectConsultType
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), needSelectConsultType = ref11[0], setNeedSelectConsultType = ref11[1];
    // set recoild state selectedConsultTypeState
    var setSelectedConsultType = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .selectedConsultTypeState */ .vo);
    var hasUnpaidTextConsult = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.cartItems) === null || ref === void 0 ? void 0 : ref.some(function(cartItem) {
            var ref;
            var isTextConsult = cartItem.consultationSessionType === graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ConsultationSessionType.Text;
            var ref1;
            var hasPaidEvaluation = (ref1 = cart === null || cart === void 0 ? void 0 : (ref = cart.paidCompletedEvaluationIds) === null || ref === void 0 ? void 0 : ref.includes(cartItem.product.evaluationId[platform])) !== null && ref1 !== void 0 ? ref1 : false;
            return isTextConsult && !hasPaidEvaluation;
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.cartItems,
        cart === null || cart === void 0 ? void 0 : cart.paidCompletedEvaluationIds,
        platform
    ]);
    var setShowPriceSelectionStep = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useSetRecoilState */ .Zl)(src_states__WEBPACK_IMPORTED_MODULE_11__/* .priceModalShowPriceStep */ .y);
    var onConfirmPriceClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(priceId) {
            var consultType, existedItem, result, oldPriceId, ref, _args = arguments;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        consultType = _args.length > 1 && _args[1] !== void 0 ? _args[1] : graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ConsultationSessionType.Text;
                        setIsAdding(true);
                        existedItem = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.find)(function(item) {
                            return item.product.id === selectedProduct.id;
                        }, cart.cartItems);
                        ;
                        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isNil)(existedItem)) {
                            _ctx.next = 14;
                            break;
                        }
                        oldPriceId = existedItem.price.id;
                        if (!(oldPriceId === priceId)) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            onClosePriceModal();
                        }
                        _ctx.next = 12;
                        break;
                    case 10:
                        _ctx.next = 12;
                        return updateCartItemById({
                            input: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                cartItem: {
                                    sysId: existedItem.sysId,
                                    productId: selectedProduct.id,
                                    priceId: priceId
                                },
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.updateCartItemById;
                                                setCart(result);
                                                onClosePriceModal();
                                                setOrderCalculation(result.calculation);
                                                queryClient.invalidateQueries([
                                                    "getExcludedEvaluationIds"
                                                ]);
                                            case 5:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 12:
                        _ctx.next = 17;
                        break;
                    case 14:
                        ;
                        _ctx.next = 17;
                        return insertCartItemById({
                            input: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                productId: selectedProduct.id,
                                selectedPriceId: priceId,
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            }), {
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                completedEval: {
                                    evalId: selectedProduct === null || selectedProduct === void 0 ? void 0 : (ref = selectedProduct.evaluationId) === null || ref === void 0 ? void 0 : ref[platform]
                                },
                                utm: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getUtm */ .PB)(),
                                tracking: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTracking */ .Ac)(),
                                consultationSessionType: consultType
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.insertCartItemById;
                                                if (!result) {
                                                    _ctx.next = 10;
                                                    break;
                                                }
                                                setCart(result);
                                                onClosePriceModal();
                                                queryClient.invalidateQueries([
                                                    "getExcludedEvaluationIds"
                                                ]);
                                                if (!isBuyNow) {
                                                    _ctx.next = 8;
                                                    break;
                                                }
                                                _ctx.next = 8;
                                                return next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/checkout");
                                            case 8:
                                                setOrderCalculation(result.calculation);
                                                updateSuggestionItems(selectedProduct.id);
                                            case 10:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 17:
                        setIsAdding(false);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(priceId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        selectedProduct,
        isBuyNow,
        promoCode,
        isSuggestion
    ]);
    var updateSuggestionItems = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(productId) {
        setSuggestionItems(suggestionItems === null || suggestionItems === void 0 ? void 0 : suggestionItems.filter(function(product) {
            return product.id !== productId;
        }));
    }, [
        suggestionItems
    ]);
    var checkCart = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, newCartData;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isNil)(cart.sysId)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 3;
                        return refetch();
                    case 3:
                        ref = _ctx.sent;
                        newCartData = ref.data;
                        setCart(newCartData.getCart);
                        return _ctx.abrupt("return", newCartData.getCart.sysId);
                    case 7:
                        return _ctx.abrupt("return", cart.sysId);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var onAddToCartClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var ref, ref1, ref2, validPlatforms, ref3, evalId, orderGynaeHormoneTest, ref4;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        validPlatforms = ((ref = product.metadata) === null || ref === void 0 ? void 0 : ref.platform.split(",")) || [];
                        if (validPlatforms.includes(patient === null || patient === void 0 ? void 0 : patient.fromPlatformEnv)) {
                            _ctx.next = 5;
                            break;
                        }
                        setIsConflictPlatformModalOpened({
                            conflict: true,
                            shouldPlatform: (0,lodash__WEBPACK_IMPORTED_MODULE_1__.capitalize)(platform)
                        });
                        return _ctx.abrupt("return");
                    case 5:
                        ;
                        evalId = (ref3 = product === null || product === void 0 ? void 0 : (ref1 = product.evaluationId) === null || ref1 === void 0 ? void 0 : ref1[platform]) !== null && ref3 !== void 0 ? ref3 : "";
                        orderGynaeHormoneTest = cart === null || cart === void 0 ? void 0 : (ref2 = cart.cartItems) === null || ref2 === void 0 ? void 0 : ref2.map(function(currentCart) {
                            return currentCart.product.uniqName;
                        });
                        if (!isUpdating) {
                            ;
                            if (checkOrderGynaeHormoneTest(product, orderGynaeHormoneTest)) {
                                setSameEvalModalOpened(true);
                                setSameEvalId(product.uniqName);
                            } else if (excludedEvalIds.includes(evalId)) {
                                setSameEvalModalOpened(true);
                                setSameEvalId(evalId);
                            } else if ((product === null || product === void 0 ? void 0 : (ref4 = product.prices) === null || ref4 === void 0 ? void 0 : ref4.length) === 1 && product.metadata.bundle !== "true") {
                                onOTCHandler(product);
                            } else {
                                setSelectedProduct(product);
                                toggleModal(true);
                            }
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        isUpdating,
        excludedEvalIds
    ]);
    var onEditPriceClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cartItem) {
            var ref;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setSelectedProduct((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, cartItem.product), {
                            isSubscriptionPrice: cartItem.isSubscriptionPrice
                        }));
                        setPreselectPrice({
                            priceId: cartItem === null || cartItem === void 0 ? void 0 : (ref = cartItem.price) === null || ref === void 0 ? void 0 : ref.id
                        });
                        toggleModal(true);
                        if (cartItem.consultationSessionType) {
                            setSelectedConsultType(cartItem.consultationSessionType);
                            setShowPriceSelectionStep(true);
                        } else {
                            setSelectedConsultType(graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ConsultationSessionType.Text);
                            setShowPriceSelectionStep(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(cartItem) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart
    ]);
    var onBuyNowClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var ref, ref1, ref2, ref3, evalId, productName, ref4, orderGynaeHormoneTest, orderGynaeHormoneTest1, requiresPrescription, ref5, hasCompletedEval, ref6;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        evalId = (product === null || product === void 0 ? void 0 : (ref = product.evaluationId) === null || ref === void 0 ? void 0 : (ref1 = ref[platform]) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
                        productName = (product === null || product === void 0 ? void 0 : product.uniqName) || (0,src_utils__WEBPACK_IMPORTED_MODULE_12__/* .convertStringToEnumKey */ .Os)(product === null || product === void 0 ? void 0 : product.name);
                        if (![
                            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.GynaeConsult,
                            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.GynaeConsultHormoneTest
                        ].includes(productName)) {
                            _ctx.next = 14;
                            break;
                        }
                        if (!GynaeGroupProducts.includes(productName)) {
                            _ctx.next = 11;
                            break;
                        }
                        ;
                        orderGynaeHormoneTest = cart === null || cart === void 0 ? void 0 : (ref4 = cart.cartItems) === null || ref4 === void 0 ? void 0 : ref4.map(function(c) {
                            return c.uniqName;
                        });
                        if (!checkOrderGynaeHormoneTest(product, orderGynaeHormoneTest)) {
                            _ctx.next = 11;
                            break;
                        }
                        setSameEvalModalOpened(true);
                        setSameEvalId(productName);
                        return _ctx.abrupt("return");
                    case 11:
                        if (!(productName === graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.GynaeConsult)) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return", next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/prenatal/gyn"));
                    case 13:
                        return _ctx.abrupt("return", next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/hormoneTest?productId=".concat(product.id)));
                    case 14:
                        if (!(productName === graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.FertilityCoach)) {
                            _ctx.next = 19;
                            break;
                        }
                        setIsDetailModalOpened(false);
                        _ctx.next = 18;
                        return next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/prenatal/coach");
                    case 18:
                        return _ctx.abrupt("return");
                    case 19:
                        orderGynaeHormoneTest1 = cart === null || cart === void 0 ? void 0 : (ref2 = cart.cartItems) === null || ref2 === void 0 ? void 0 : ref2.map(function(currentCart) {
                            return currentCart.product.uniqName;
                        });
                        if (!checkOrderGynaeHormoneTest(product, orderGynaeHormoneTest1)) {
                            _ctx.next = 24;
                            break;
                        }
                        setSameEvalModalOpened(true);
                        setSameEvalId(product.uniqName);
                        return _ctx.abrupt("return");
                    case 24:
                        requiresPrescription = product.metadata.requires_prescription;
                        if (!src_config__WEBPACK_IMPORTED_MODULE_9__/* .ENABLE_NEW_PRESCRIPTION_FLOW */ .Lh) {
                            _ctx.next = 32;
                            break;
                        }
                        if (!requiresPrescription) {
                            _ctx.next = 30;
                            break;
                        }
                        ;
                        hasCompletedEval = completedEvalIds.includes(product === null || product === void 0 ? void 0 : (ref5 = product.evaluationId) === null || ref5 === void 0 ? void 0 : ref5[platform]);
                        return _ctx.abrupt("return", next_router__WEBPACK_IMPORTED_MODULE_3___default().push(hasCompletedEval ? (0,src_constants_url_constants__WEBPACK_IMPORTED_MODULE_10__/* .URL_PRESCRIPTION_FLOW_WITH_EVAL_ID_V2 */ .rm)(evalId) : (0,src_constants_url_constants__WEBPACK_IMPORTED_MODULE_10__/* .URL_PATIENT_EVAL_V2 */ .EK)(evalId)));
                    case 30:
                        _ctx.next = 39;
                        break;
                    case 32:
                        ;
                        if ([
                            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.CovidTeleconsult,
                            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ProductNameType.SexTherapy
                        ].includes(product.uniqName)) {
                            // treat this product like otc product
                            requiresPrescription = false;
                        }
                        if (!(requiresPrescription && !completedEvalIds.includes(product === null || product === void 0 ? void 0 : (ref6 = product.evaluationId) === null || ref6 === void 0 ? void 0 : ref6[platform]))) {
                            _ctx.next = 39;
                            break;
                        }
                        toggleModal(false);
                        _ctx.next = 38;
                        return next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/evaluation/".concat(evalId, "?productId=").concat(product.id));
                    case 38:
                        return _ctx.abrupt("return");
                    case 39:
                        if (!((product === null || product === void 0 ? void 0 : (ref3 = product.prices) === null || ref3 === void 0 ? void 0 : ref3.length) === 1 && product.metadata.bundle !== "true" || product.metadata.HasEvaluation === "false")) {
                            _ctx.next = 42;
                            break;
                        }
                        onOTCHandler(product, true);
                        return _ctx.abrupt("return");
                    case 42:
                        setIsBuyNow(true);
                        onAddToCartClick(product);
                    case 44:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        pendingEvalIds,
        completedEvalIds,
        excludedEvalIds
    ]);
    // already remove this feature. Someplace still use it. Will check and remove later
    var onThankYouBuyNowClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var ref, newCartId, ref1, ref2;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return checkCart();
                    case 3:
                        newCartId = _ctx.sent;
                        if (!((product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.length) === 1)) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        _ctx.next = 8;
                        return insertCartItemById({
                            input: {
                                sysId: newCartId,
                                productId: product.id,
                                selectedPriceId: product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.id,
                                shouldReturnCalculation: false,
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getUtm */ .PB)(),
                                tracking: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTracking */ .Ac)()
                            }
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.insertCartItemById;
                                                if (!result) {
                                                    _ctx.next = 5;
                                                    break;
                                                }
                                                setCart(result);
                                                _ctx.next = 5;
                                                return next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/checkout");
                                            case 5:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 8:
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            setIsBuyNow(true);
                            toggleModal(true);
                            setSelectedProduct(product);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        isSuggestion
    ]);
    // already remove this feature. Someplace still use it. Will check and remove later
    var onThankYouAddToCartClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var newCartId, ref;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return checkCart();
                    case 2:
                        newCartId = _ctx.sent;
                        if (isUpdating) {
                            _ctx.next = 11;
                            break;
                        }
                        ;
                        if (!((product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.length) === 1)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 8;
                        return insertCartItemById({
                            input: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: newCartId,
                                productId: product.id,
                                selectedPriceId: product.prices[0].id,
                                shouldReturnCalculation: false
                            }, promoCode && {
                                promotionCode: promoCode
                            }), {
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getUtm */ .PB)(),
                                tracking: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTracking */ .Ac)()
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.insertCartItemById;
                                                if (result) {
                                                    setCart(result);
                                                }
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 8:
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            toggleModal(true);
                            setSelectedProduct(product);
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        isSuggestion
    ]);
    var onOTCHandler = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var redirect, autoRenewal, ref, ref1, evalId, _args = arguments;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        redirect = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false, autoRenewal = _args.length > 2 && _args[2] !== void 0 ? _args[2] : true;
                        ;
                        ;
                        evalId = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.evaluationId) === null || ref === void 0 ? void 0 : ref[platform]) !== null && ref1 !== void 0 ? ref1 : "";
                        setIsUpdating(true);
                        if (!excludedEvalIds.includes(evalId)) {
                            _ctx.next = 10;
                            break;
                        }
                        setSameEvalModalOpened(true);
                        setSameEvalId(evalId);
                        setIsUpdating(false);
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return insertCartItemById({
                            input: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                productId: product.id,
                                selectedPriceId: product.prices[0].id,
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            }), {
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                utm: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getUtm */ .PB)(),
                                tracking: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTracking */ .Ac)(),
                                autoRenewal: autoRenewal
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.insertCartItemById;
                                                if (!result) {
                                                    _ctx.next = 8;
                                                    break;
                                                }
                                                setCart(result);
                                                setOrderCalculation(result.calculation);
                                                updateSuggestionItems(product.id);
                                                if (!redirect) {
                                                    _ctx.next = 8;
                                                    break;
                                                }
                                                _ctx.next = 8;
                                                return next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/checkout");
                                            case 8:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 12:
                        setIsUpdating(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(product) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        promoCode,
        isSuggestion,
        excludedEvalIds
    ]);
    var onEvalAddToCartClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var productId, priceId, completedEval, teleConsultForSkipEval, isSkipMedSelecting, patientNote, autoRenewal, data, result;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        productId = param.productId, priceId = param.priceId, completedEval = param.completedEval, teleConsultForSkipEval = param.teleConsultForSkipEval, isSkipMedSelecting = param.isSkipMedSelecting, patientNote = param.patientNote, autoRenewal = param.autoRenewal;
                        _ctx.next = 3;
                        return insertCartItemByIdAsync({
                            input: {
                                sysId: cart.sysId,
                                productId: productId,
                                selectedPriceId: priceId,
                                completedEval: completedEval,
                                teleConsultForSkipEval: teleConsultForSkipEval,
                                shouldReturnCalculation: true,
                                isSkipMedSelecting: isSkipMedSelecting,
                                fbc: localStorage.fbc,
                                fbp: localStorage.fbp,
                                patientNote: patientNote,
                                autoRenewal: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_2__.isNil)(autoRenewal) ? true : autoRenewal,
                                utm: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getUtm */ .PB)(),
                                tracking: (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTracking */ .Ac)(),
                                consultationSessionType: (completedEval === null || completedEval === void 0 ? void 0 : completedEval.consultType) || graphql_generated__WEBPACK_IMPORTED_MODULE_7__.ConsultationSessionType.Video
                            }
                        });
                    case 3:
                        data = _ctx.sent;
                        result = data === null || data === void 0 ? void 0 : data.insertCartItemById;
                        if (result) {
                            setCart(result);
                            setOrderCalculation(result.calculation);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        isSuggestion
    ]);
    var onQuantityChange = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var productId, cartItemId, quantity;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        productId = param.productId, cartItemId = param.cartItemId, quantity = param.quantity;
                        setIsUpdating(true);
                        _ctx.next = 4;
                        return updateCartItemById({
                            input: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                cartItem: {
                                    sysId: cartItemId,
                                    productId: productId,
                                    quantity: quantity
                                },
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.updateCartItemById;
                                                if (result) {
                                                    setCart(result);
                                                    setOrderCalculation(result.calculation);
                                                }
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 4:
                        setIsUpdating(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        promoCode
    ]);
    var onRemoveItemClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cartItem) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsUpdating(true);
                        setIsRemoving(true);
                        _ctx.next = 4;
                        return deleteCartItemById({
                            input: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                cartItemId: cartItem.sysId,
                                sysId: cart.sysId,
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData.deleteCartItemById;
                                                if (result) {
                                                    setCart(result);
                                                    setOrderCalculation(result.calculation);
                                                    setModalCancelingItem(null);
                                                }
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 4:
                        setIsUpdating(false);
                        setIsRemoving(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(cartItem) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        promoCode
    ]);
    var onOpenCancelModal = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(cartItem) {
        setModalCancelingItem(cartItem);
    }, []);
    var onClosePriceModal = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        setIsBuyNow(false);
        toggleModal(false);
        setIsDetailModalOpened(false);
    }, []);
    var onTogglePriceClick = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cartItem) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsUpdating(true);
                        _ctx.next = 3;
                        return updateCartItemById({
                            input: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                cartItem: {
                                    sysId: cartItem.sysId,
                                    productId: cartItem.product.id,
                                    isSubscriptionPrice: !cartItem.isSubscriptionPrice,
                                    isAutoRenew: !cartItem.isSubscriptionPrice
                                },
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.updateCartItemById;
                                                if (result) {
                                                    setCart(result);
                                                    setOrderCalculation(result.calculation);
                                                }
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 3:
                        setIsUpdating(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(cartItem) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        promoCode
    ]);
    var onToggleAutoRenew = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cartItem) {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsUpdating(true);
                        _ctx.next = 3;
                        return updateCartItemById({
                            input: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                sysId: cart.sysId,
                                cartItem: {
                                    sysId: cartItem.sysId,
                                    productId: cartItem.product.id,
                                    isSubscriptionPrice: cartItem.isSubscriptionPrice,
                                    isAutoRenewal: !cartItem.isAutoRenewal
                                },
                                shouldReturnCalculation: true
                            }, promoCode && {
                                promotionCode: promoCode
                            })
                        }, {
                            onSuccess: function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(successData) {
                                    var result;
                                    return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                result = successData === null || successData === void 0 ? void 0 : successData.updateCartItemById;
                                                if (result) {
                                                    setCart(result);
                                                    setOrderCalculation(result.calculation);
                                                }
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(successData) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        });
                    case 3:
                        setIsUpdating(false);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(cartItem) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        promoCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        // ex: selectedProduct.evaluationId = { "noah": "ed" }
        var evaluationId = Object.values((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.evaluationId) || {})[0];
        var value = evaluationId && [
            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvalIds.Ed,
            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvalIds.Pe,
            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.EvalIds.Hairloss
        ].includes(evaluationId) && (0,src_utils_checkCountry__WEBPACK_IMPORTED_MODULE_13__/* .checkCountry */ .d)([
            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.RegionType.Hk,
            graphql_generated__WEBPACK_IMPORTED_MODULE_7__.RegionType.Jp
        ]);
        setNeedSelectConsultType(value);
    }, [
        selectedProduct
    ]);
    return {
        onAddToCartClick: onAddToCartClick,
        onQuantityChange: onQuantityChange,
        onRemoveItemClick: onRemoveItemClick,
        onConfirmPriceClick: onConfirmPriceClick,
        onOpenCancelModal: onOpenCancelModal,
        onBuyNowClick: onBuyNowClick,
        onEvalAddToCartClick: onEvalAddToCartClick,
        onClosePriceModal: onClosePriceModal,
        onTogglePriceClick: onTogglePriceClick,
        onToggleAutoRenew: onToggleAutoRenew,
        onEditPriceClick: onEditPriceClick,
        isModalOpened: isModalOpened,
        isUpdating: isUpdating,
        onThankYouBuyNowClick: onThankYouBuyNowClick,
        onThankYouAddToCartClick: onThankYouAddToCartClick,
        completedEvalIds: completedEvalIds,
        skippedEvalIds: skippedEvalIds,
        platform: platform,
        cart: cart,
        promoCode: promoCode,
        pendingEvalIds: pendingEvalIds,
        onOTCHandler: onOTCHandler,
        setSameEvalModalOpened: setSameEvalModalOpened,
        setSameEvalId: setSameEvalId,
        setCart: setCart,
        needSelectConsultType: needSelectConsultType,
        hasUnpaidTextConsult: hasUnpaidTextConsult
    };
};
/* harmony default export */ __webpack_exports__["ZP"] = (useCartHooks);


/***/ })

}]);